(function() {
  if (window.ArcticKortmarkedMaintenance) return;

  function markup(compact) {
    return '' +
      '<div class="arctic-km-maintenance' + (compact ? ' arctic-km-maintenance--compact' : '') + '" role="status" aria-live="polite" aria-atomic="true">' +
        '<span class="arctic-km-maintenance__icon" aria-hidden="true">&#9881;</span>' +
        '<h2 class="arctic-km-maintenance__title">Kortmarkedet er midlertidig utilgjengelig</h2>' +
        '<p class="arctic-km-maintenance__text">Serveren er midlertidig nede for nødvendig vedlikehold. Vi jobber med saken og er tilbake så raskt som mulig.</p>' +
        '<p class="arctic-km-maintenance__note">Resten av nettbutikken kan brukes som normalt.</p>' +
        '<button class="arctic-km-maintenance__retry" type="button" data-arctic-km-retry>Prøv igjen</button>' +
      '</div>';
  }

  function show(target, countTarget, retryCallback, compact) {
    if (!target) return;
    target.classList.remove('is-updating');
    target.innerHTML = markup(!!compact);
    if (countTarget) countTarget.textContent = 'Midlertidig utilgjengelig';
    var scope = target.closest('[data-kortmarked-root]');
    var pagination = scope && scope.querySelector('[data-km-pagination]');
    if (pagination) pagination.hidden = true;

    var retryButton = target.querySelector('[data-arctic-km-retry]');
    if (!retryButton) return;
    retryButton.addEventListener('click', function() {
      retryButton.disabled = true;
      retryButton.textContent = 'Prøver igjen…';
      if (countTarget) countTarget.textContent = 'Kobler til…';
      if (typeof retryCallback === 'function') retryCallback();
      else window.location.reload();
    }, { once: true });
  }

  window.ArcticKortmarkedMaintenance = {
    markup: markup,
    show: show
  };
  document.documentElement.setAttribute('data-arctic-km-maintenance-ready', 'true');
})();
